import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import QueryRequest from '../QueryRequest';

export const SEARCH_SLIDER_ITEMS = gql`
  query searchSliderItems($sliderId: Int!) {
    slider {
      searchSliderItems(sliderId: $sliderId) {
        id
        assetId
        author
        quote
        type
        text
        asset {
          s3Key
          type
        }
      }
    }
  }
`;

const searchSliderItems = ({ sliderId, onError, onSuccessResult }) => (
  <Query fetchPolicy="network-only" query={SEARCH_SLIDER_ITEMS} variables={{ sliderId }}>
    {({ loading, error, data }) => (
      <QueryRequest
        data={Object.entries(data).length !== 0 && data.slider.searchSliderItems}
        error={error}
        isLoading={loading}
        onError={onError}
        onSuccessResult={onSuccessResult}
      />
    )}
  </Query>
);
searchSliderItems.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  sliderId: PropTypes.number.isRequired,
};

export default searchSliderItems;
